import React, { useEffect, useState } from "react";
import {
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    ListItemText,
    Grid
} from "@mui/material";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import useAdminProfileUtils from "../../ProfilePlugin/utils/useAdminProfileUtils";
import { useProfile } from "../hooks/useProfile";
import ProfileService from "../service/api/profile";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { CircularProgress, Stack } from '@mui/material';
import { useSnackbar } from "notistack";
import { useRBAC } from "../../RBACPlugin";


const UpdateUserProfileComponent = (props) => {
    const { open, setOpen, selectedProfile } = props;
    const {enqueueSnackbar} = useSnackbar();

    const { isFetchingIDTypes, idTypes, getIDTypesUtil, isFetchingProfileTypes, profileTypes, getProfileTypesUtil  } = useAdminProfileUtils();
    const { updateProfile, isUpdating } = useProfile();
    const {getRoleByProfileType,  rolesList} = useRBAC()


    const [isSubmitting, setIsSubmitting] = useState(false);


    const [selectProfileType, setSelectProfileType] = useState("");
    const [idNumber, setIdNumber] = useState("");
    const [selectedRole, setSelectedRole] = useState("");
    const [idType, setSelectIDType] = useState("");

    const [confirmOpen, setConfirmOpen] = useState(false); // New state for confirmation dialog

    useEffect(() => {
        getProfileTypesUtil();
        getIDTypesUtil();
    }, []);

    useEffect(() => { 
        if (selectProfileType) {
            let parameters = {
                profileType: selectProfileType,
            }
            getRoleByProfileType(parameters)
        } else {
            let parameters = {
                profileType: selectedProfile?.profile_type,
            }
            getRoleByProfileType(parameters);
        }
    }, [selectProfileType]);

    const handleChange = (setter) => (event) => {
        setter(event.target.value);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleUpdateProfile = async () => {

        setIsSubmitting(true);

        const parameters = {
            profileUID: selectedProfile.profile_uid,
        };

        const payload = {
            profile_type: selectProfileType,
            id_type: idType,
            id_no: idNumber,
            role: selectedRole,
        };

        try {
            const updateProfileResponse = await ProfileService.updateProfile(parameters, payload);

            if(updateProfileResponse.success){
                setConfirmOpen(false); 
                setOpen(false);   
            }else{
                 setConfirmOpen(true); 
                 setOpen(true);   
            }
            
        } catch (error) {
            
            console.log("Update failed:", error);
            const errorMessage = error?.response?.data?.error_message || error.message;

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
            setIsSubmitting(false);
        }
    };


    const handleOpenConfirm = () => {
        setConfirmOpen(true);
        // setOpen(true);
    };

    const handleCloseConfirm = () => {
        setConfirmOpen(false);
        // setOpen(false);
    };

    const actions = [
        {
            label: "Confirm",
            onClick: handleOpenConfirm,
        }
    ];


    return (
        <>
            {!confirmOpen && (
                <CustomDialog
                    open={open}
                    onClose={handleClose}
                    title="Update Profile"
                    subtitle={"Update your personal details"}
                    hasDividers={true}
                    content={
                        <Box sx={{mt: 2}}>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 6 }}>
                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                        <InputLabel shrink sx={{ bgcolor: 'white' }}>Select Profile Type</InputLabel>
                                        <Select
                                            defaultValue={selectedProfile?.profile_type || ""}
                                            onChange={handleChange(setSelectProfileType)}
                                        >
                                            {profileTypes.map((name) => (
                                                <MenuItem key={name} value={name}>
                                                    {name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid size={{ xs: 6 }}>
                                    <FormControl fullWidth>
                                        <InputLabel shrink sx={{ bgcolor: 'white' }}>Select Role</InputLabel>
                                        <Select
                                            defaultValue={selectedProfile?.role || ""}
                                            onChange={handleChange(setSelectedRole)}
                                            // disabled={!selectProfileType} 
                                        >
                                             {rolesList.map((name) => (
                                                <MenuItem key={name} value={name}>
                                                    {name.role}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    
                                </Grid>
                                <Grid size={{ xs: 6 }}>
                                    <TextField
                                        label="Input ID Number"
                                        sx={{ mb: 2 }}
                                        InputLabelProps={{ shrink: true }}
                                        variant="outlined"
                                        fullWidth
                                        placeholder={selectedProfile?.id_no}
                                        onChange={handleChange(setIdNumber)}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6 }}>
                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                        <InputLabel shrink sx={{ bgcolor: 'white' }}>Select ID Type</InputLabel>
                                        <Select
                                            defaultValue={selectedProfile?.id_type || ""}
                                            onChange={handleChange(setSelectIDType)}
                                        >
                                            {idTypes.map((name) => (
                                                <MenuItem key={name} value={name}>
                                                    {name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                    }
                    actions={actions}
                    maxWidth={"md"}
                />
            )}
            {/* Confirmation Dialog */}
            <Dialog open={confirmOpen} onClose={handleCloseConfirm} maxWidth="sm" fullWidth>
                <DialogContent dividers>
                    <List sx={{ width: '100%', bgcolor: 'background.paper' }} >
                        <ListItem >
                            <ListItemAvatar>
                            {/* <Avatar> */}
                                <CheckCircleOutlineIcon color="primary" sx={{width: 80, height: 80, mr: 1}} />
                            {/* </Avatar> */}
                            </ListItemAvatar>
                            <ListItemText primary={<Typography sx={{fontSize: 18, fontWeight:'bold'}}>Confirm Update</Typography>} secondary="Are you sure you want to update this profile? This action will apply the changes immediately." />
                        </ListItem>
                    </List>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        onClick={handleCloseConfirm}
                        // color="inherit"
                        variant="outlined"
                        size="medium"
                        disabled={isSubmitting}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={handleUpdateProfile}
                        color="primary"
                        variant="contained"
                        size="medium"
                        disabled={isSubmitting}
                        startIcon={isSubmitting && <CircularProgress color="inherit" size={20} />}
                    >
                        {isSubmitting ? "Updating..." : "Confirm"}
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    );
};

export default UpdateUserProfileComponent;
